<onyx-modal
  variant="center"
  heading="{{ `${I18N}.${data.mode}Unavailability` | translate }}: {{
    (data.type === UnavailabilityType.EMPLOYEE
      ? data.item
      : data.item.driverData
    ) | onyxName
  }}"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <form [formGroup]="form" [onyxAutoFocus]="data.mode">
    @let controls = form.controls;
    <onyx-datepicker
      [formControl]="controls.dateRange"
      label="labels.from"
      labelTo="labels.to"
      [showDateRange]="true"
      [yearsRange]="{ past: 0, future: 10 }"
    ></onyx-datepicker>

    <div class="group">
      <onyx-dropdown
        [formControl]="controls.reason"
        label="labels.reason"
        [options]="$any(unavailabilityReasons$ | async)"
      ></onyx-dropdown>

      <onyx-upload
        [formControl]="controls.file"
        [label]="`${I18N}.documentary`"
      ></onyx-upload>
    </div>
  </form>

  @if (data.mode === OnyxFormMode.EDIT) {
    <onyx-button
      bottomLeftOptions
      variant="outlined"
      color="red"
      (click)="delete()"
    >
      {{ 'labels.delete' | translate }}
    </onyx-button>
  }

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button [spinner]="loading()" (click)="!loading() ? submit() : null">
      {{
        (data.mode === OnyxFormMode.ADD ? 'labels.add' : 'labels.save')
          | translate
      }}
    </onyx-button>
  </ng-container>
</onyx-modal>
